import { Flex, Input } from '@chakra-ui/react'
import Clean from '../../../components/Clean'
import { listSupply } from '../storage'

export default function FiltersSupply() {
    const { clear, ...props } = listSupply.useSearch()

    return (
        <Flex>
            <Clean value={props.value} onClick={clear}>
                <Input w="80" placeholder="🏸 Buscar por nombre" {...props} />
            </Clean>
        </Flex>
    )
}
